/* import */
import { ConfigInfo } from '@/js/properties/connection';
import axios from 'axios';
import { ERRTYPE } from '@/js/properties/config';
import GigyaApi from '@/js/Common/common-gigyaapi';
import CommonJs from '@/js/Common/common';

let client = axios.create({
  baseURL : ConfigInfo.API_GW_RMS
});

/**
 * モニタリング登録可能なデバイス最大数の取得
 * 
 *  @param  : userId ユーザーID
 *  @param  : organizationId 組織ID
 *  @return : ライセンス最大数
 * 
 */
 async function getMaxLicenseCount(result, userId, organizationId, venueId)
 {
  try{
    let params = {
      userId: userId,
      orgId: organizationId,
      venueId: venueId,
    };
    let tmp = await client.get('organization/get-total-license', { params } );
    
    if (tmp.data.errorCode === undefined) {
      result.maxDeviceCount = tmp.data.results.capacity;
      result.licenseCode = tmp.data.results.licenseCode;
    }
    else {
      return false;
    }
  }
  catch(err){
    // console.log(err);
    return false;
  }
  return true;
 }

 /**
 * Identify通知
 * 
 *  @param  : device デバイス情報
 *  @param  : me 呼び出し元情報
 *  @return : エラーメッセージ
 * 
 */
async function identifyEvent(device, me)
{
  let errorMessage = "";
  try {
    const accountInfo = await GigyaApi.getAccountInfo();
    if (!accountInfo || accountInfo.errorMessage === me.$t('DIALOG_ERROR_ALERT_UNAUTHORIZED_USER').MSG) {
      return CommonJs.makeErrMsg(ERRTYPE.G4.CD, ERRTYPE.G4.MSG);
    }

    /* ==================================== */
    /* デバイス登録                         */
    /* ==================================== */
    let params = {
      userId: me.$store.state.SerialId,
      venueId: me.$store.state.VenueId,
      productName: device.product_name,
      uniqueId: device.unique_id,
      UIDSignature: accountInfo.UIDSignature,
      signatureTimestamp: accountInfo.signatureTimestamp,
    };
    let result = await client.post('project/venue/identify-device', { params } );
    /* 共通エラーコードチェック */
    if (result.data.errorCode !== undefined) {
      switch(result.data.errorCode) {
        case ERRTYPE.RM11.CD:
          errorMessage = me.$t('DIALOG_ERROR_ALERT_IDENTIFY').MSG;
          break;
        default:
          errorMessage = me.$t('DIALOG_ERROR_ALERT_DB_ACCESS').MSG;
          break;
      }
      errorMessage =  CommonJs.makeErrMsg(result.data.errorCode, errorMessage);
    }
  }
  catch(err) {
    errorMessage =  CommonJs.makeErrMsg(ERRTYPE.G3.CD, me.$t('DIALOG_ERROR_ALERT_DB_ACCESS').MSG);
  }
  return errorMessage;
}

export default {

  getMaxLicenseCount,
  identifyEvent,
};
